import { post } from 'core_main/request';

import memoize from '@danieldietrich/async-memoize';
import { InitAssistantParameters } from './types';
import {
  validateInitAssistantParams,
  makeInitAssistantEndpoint,
} from './helpers';

const initAssistantApiCall = (parameters: InitAssistantParameters) => {
  const validationError = validateInitAssistantParams(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  const { assistant, dialog } = parameters;

  return post(makeInitAssistantEndpoint(parameters), {
    body: JSON.stringify({
      assistant,
      dialog,
    }),
  });
};
export const initAssistant = memoize(initAssistantApiCall);
